
export { MarketingBannerCarousel } from "/home/runner/work/capsicum/capsicum/libs/features/feeds/web/src/ui/marketing-banner-carousel/MarketingBannerCarousel.tsx"